/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import {useNavigate} from 'react-router-dom'
import {appsAPI} from '../../../../services/AppsService'
import {useIntl} from 'react-intl'

type Props = {
  appId: string
  show: boolean
  handleClose: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body
const DeleteAppModal: FC<Props> = ({appId, show, handleClose}) => {
  const intl = useIntl()
  const [appDelete] = appsAPI.useAppDeleteMutation()
  const [inputId, setInputID] = useState<string>('')
  const [isDisabled, setIsDisabled] = useState<boolean>(true)
  const navigate = useNavigate()

  useEffect(() => {
    if (inputId === appId) {
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }, [appId, handleClose, inputId])

  const handleDelete = () => {
    navigate(-1)
    appDelete(appId).catch(() => {
      navigate(-1)
      handleClose()
    })
  }

  return createPortal(
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{intl.formatMessage({id: 'APPS.DELETE.MODAL.TITTLE'})}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex flex-column bd-highlight'>
          <h5 className='text-danger mb-4'>{intl.formatMessage({id: 'APPS.DELETE.MODAL.MESSAGE'})}</h5>
          <input
            type='text'
            className='form-control form-control-sm form-control-solid mb-4 text-gray-900'
            placeholder={intl.formatMessage({id: 'APPS.ID'})}
            onChange={(e) => setInputID(e.target.value)}
          />
          <button className='btn btn-sm btn-danger' onClick={handleDelete} disabled={isDisabled}>
            {intl.formatMessage({id: 'APPS.DELETE.BUTTON'})}
          </button>
        </div>
      </Modal.Body>
    </Modal>,
    modalsRoot
  )
}

export {DeleteAppModal}
